import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useImperativeHandle, useEffect } from 'react';
import './styles.css';


var styles = {
    "searchResult": "SearchFieldResult-module_searchResult__H69Nt",
    "searchResultTitle": "SearchFieldResult-module_searchResultTitle__evurK"
};

const SearchFieldResult = /*#__PURE__*/ forwardRef(({ title, hasFocus, setFocus, index, onClick, children }, ref)=>{
    const liRef = useRef(null);
    useImperativeHandle(ref, ()=>liRef?.current);
    useEffect(()=>{
        if (hasFocus) {
            liRef.current?.focus();
        }
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ jsxs("li", {
        ref: liRef,
        className: styles.searchResult,
        tabIndex: hasFocus ? 0 : -1,
        role: 'option',
        "aria-selected": hasFocus,
        onKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                onClick?.();
            }
        },
        onClick: ()=>{
            setFocus(index);
            onClick?.();
        },
        children: [
            /*#__PURE__*/ jsx("div", {
                className: styles.searchResultTitle,
                children: title
            }),
            children
        ]
    });
});
SearchFieldResult.displayName = 'SearchFieldResult';

export { SearchFieldResult as default };
